// ----------------------------------------------------------------------------
// Component: Ingredients LP Filters
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_main-ingredients.scss';

// -------------------------------------
// Variables
// -------------------------------------
var INGREDIENTS_PRODUCTS_SELECTOR = '.ingredient-products';
var TOGGLE_PRODUCTS_BTN = '.toggle-products';
var PRODUCTS_LIST = '.product-list';
var BENEFIT_FILTER_BTN = '.filter-options .filter-option';
var CLEAR_FILTERS_BTN_SELECTOR = '#clear-ingredients-filters';
var CLEAR_FILTERS_BTN = document.querySelector(CLEAR_FILTERS_BTN_SELECTOR);
var INGREDIENTS_ITEM = '.ingredient';
document.querySelectorAll(INGREDIENTS_PRODUCTS_SELECTOR).forEach(element => {
  var toggleButton = element.querySelector(TOGGLE_PRODUCTS_BTN);
  var productList = element.querySelector(PRODUCTS_LIST);
  if (!toggleButton || !productList) return;
  toggleButton.addEventListener('click', event => {
    event.preventDefault();
    var isOpen = productList.classList.toggle('open');
    toggleButton.innerText = isOpen ? 'Hide Products' : 'View Products';
  });
});
var filterButtons = document.querySelectorAll(BENEFIT_FILTER_BTN);
var ingredients = document.querySelectorAll(INGREDIENTS_ITEM);
filterButtons.forEach(button => {
  button.addEventListener('click', () => {
    var selectedBenefit = button.getAttribute('value');
    var selectedSearch = button.getAttribute('search');
    if (!selectedBenefit || !selectedSearch) return;
    CLEAR_FILTERS_BTN === null || CLEAR_FILTERS_BTN === void 0 || CLEAR_FILTERS_BTN.classList.remove('hidden');
    var activeButton = document.querySelector("".concat(BENEFIT_FILTER_BTN, ".active"));
    activeButton === null || activeButton === void 0 || activeButton.classList.remove('active');
    button.classList.add('active');
    ingredients.forEach(ingredient => {
      var dataAttr = ingredient.getAttribute("data-".concat(selectedSearch));
      var values = dataAttr ? dataAttr.split(',') : [];
      ingredient.style.display = values.includes(selectedBenefit) ? '' : 'none';
    });
  });
});
CLEAR_FILTERS_BTN === null || CLEAR_FILTERS_BTN === void 0 ? void 0 : CLEAR_FILTERS_BTN.addEventListener('click', () => {
  ingredients.forEach(ingredient => {
    ingredient.style.display = '';
  });
  var activeButton = document.querySelector("".concat(BENEFIT_FILTER_BTN, ".active"));
  activeButton === null || activeButton === void 0 || activeButton.classList.remove('active');
  CLEAR_FILTERS_BTN.classList.add('hidden');
});